import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import CommonButton from '../../common/CommonButton';
import { EditorFormats, EditorModules } from './NewTicket';
import ReactQuill from 'react-quill';
import { TicketDetails } from './TicketDetails';
import Box from '@material-ui/core/Box';
import { Button } from '@material-ui/core';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import PropTypes from 'prop-types';

export const TicketReply = ({ ticketId, userId, email, classes, setIsSnackbarOpen, postTicketReply }) => {
  const [content, setContent] = useState('');
  const [replyTicketId, setReplyTicketId] = useState(null);
  const [animation] = useAutoAnimate();
  
  const resetReplyState = () => {
    setContent('');
    setReplyTicketId(null);
  };
  
  const handleSendClick = (ticketId) => {
    if (!content.trim()) return;
    postTicketReply(ticketId, content, userId, setIsSnackbarOpen).then(() => resetReplyState());
  };
  
  const handleReplyClick = () => {
    setReplyTicketId(ticketId);
  };
  
  return (
    <div ref={animation} className={classes.newReplySection}>
      {!replyTicketId && <CommonButton
        className={classes.addCommentReplyBtn}
        isAnimated
        onClick={handleReplyClick}
        label={<FormattedMessage id="new.reply" defaultMessage="New reply" />}
      />}
  
      {replyTicketId === ticketId && <div className={classes.task}>
        <div className={classes.ticketWrapper}>
          <TicketDetails name={email} isUser={true} classes={classes} />
          <ReactQuill
            className={classes.ticketContent}
            theme="snow"
            value={content}
            onChange={setContent}
            formats={EditorFormats}
            modules={EditorModules}
          />
          <Box className={classes.buttonsWrapper}>
            <Button className={classes.customButton} onClick={() => setReplyTicketId(null)}>
              <FormattedMessage id="freshdesk.cancel.button" defaultMessage="Cancel" />
            </Button>
            <Button
              className={classes.customButton}
              onClick={() => handleSendClick(ticketId)}
              disabled={!content.trim()}>
              <FormattedMessage id="freshdesk.send.button" defaultMessage="Send" />
            </Button>
          </Box>
        </div>
      </div>}

    </div>
  );
};

TicketReply.propTypes = {
  ticketId: PropTypes.number,
  userId: PropTypes.number,
  email: PropTypes.string,
  classes: PropTypes.object,
  setIsSnackbarOpen: PropTypes.func,
  postTicketReply: PropTypes.func,
};

const decorate = compose(
  connect(store => ({
      user: store.user.profile,
    })
  ),
);

export default decorate(TicketReply);

